
import {Component} from './base';

interface Title {
  id: string;
  name: string;
}
interface Style {
  id: number;
  name: string;
  color: string;
  bgcolor: string;
}

export class CalendarFiltersComponent extends Component {
  private game: string;

  private searchText: string = '';
  private titles: Title[] = [];
  private titlesLoaded: boolean = false;
  private selectedTitles: Title[] = [];
  private styles: Style[] = [];
  private stylesLoaded: boolean = false;
  private selectedStyles: Style[] = [];

  public static shouldLoad() {
    return $('.calendar-filter').length > 0;
  }

  public register() {
    this.app.eventManager.registerEvent({
      code: 'calendar-filters.change'
    });
  }

  public load() {
    this.game = $('#hidden-game-short').val() as string;

    this.renderFilterList('title');
    this.renderFilterList('style');
    this.renderSelectedSummary();

    this.initFilters();
    const self = this;

    $('body').on('change', 'input.filter-inputs', function() {
      self.submitFilter($(this));
    });
    $('body').on('click', '#calendar-clear-filters', function() {
      self.clearAllFilters();
    });
    $('body').on('click', '.calendar-filter-chip__remove', function() {
      self.removeChip($(this));
    });

    $('body').on('keypress', 'input#search', function (e) {
      if (e.which === 13) {
        self.submitSearch($(this));
      }
    });
    $('body').on('click', '#search-submit', function() {
      self.submitSearch($('input#search'));
    });
    $('body').on('click', '#search-clear', function() {
      self.clearSearch();
    });
  }

  public initFilters() {
    $.getJSON(`/calendar/${this.game}/filters`).then((res) => {
      if (res.titles) {
        this.titles = res.titles;
      }
      if (res.styles) {
        this.styles = res.styles;
      }
      this.titlesLoaded = true;
      this.stylesLoaded = true;

      this.renderFilterList('title');
      this.renderFilterList('style');
      this.syncFilterUi();
    });
  }

  public renderFilterList(type: string) {
    const listElement = $(`#${type}-filter-list`);
    const optionList: any[] = type === 'title' ? this.titles : this.styles;
    const selectedList: any[] = type === 'title' ? this.selectedTitles : this.selectedStyles;

    listElement.empty();

    if (! optionList.length) {
      const isLoaded = type === 'title' ? this.titlesLoaded : this.stylesLoaded;
      const loadingText = type === 'title'
        ? (isLoaded ? 'No title filters available right now.' : 'Loading title filters...')
        : (isLoaded ? 'No style filters available right now.' : 'Loading style filters...');
      listElement.append(`<li class="mc-calendar-filter-list__placeholder">${loadingText}</li>`);
      return;
    }

    for (const option of optionList) {
      const selected = selectedList.indexOf(option) !== -1 ? 'checked="checked"' : '';
      const colorBadge = type === 'style'
        ? `<span class="mc-calendar-filter-option__swatch" style="color:#${option.color || '000000'};background:#${option.bgcolor || 'ffffff'};"></span>`
        : '';

      listElement.append(`
        <li class="mc-calendar-filter-option">
          <label class="mc-calendar-filter-option__label">
            <input type="checkbox" name="${type}-filter" data-type="${type}" class="filter-inputs" ${selected} value="${option.id}" />
            <span class="mc-calendar-filter-option__copy">
              ${colorBadge}
              <span>${option.name}</span>
            </span>
          </label>
        </li>
      `);
    }
  }

  /**
   * Submit search phrase.
   * @param {JQuery<HTMLElement>} element
   */
  private submitSearch(element: JQuery<HTMLElement>) {
    const value = ((element.val() as string) || '').trim();

    this.searchText = value.length > 0 ? value : '';
    $('input#search').val(this.searchText);
    this.applyFilters();
  }

  /**
   * Change action for element and value.
   */
  private submitFilter(element: JQuery<HTMLElement>) {
    const type = element.data('type') as string;
    const identifier = element.val() as string;

    if (type === 'title') {
      let selected: Title|null = null;
      for (const title of this.titles) {
        if (title.id === identifier) {
          selected = title;
          break;
        }
      }
      if (! selected) return;

      if (element.is(':checked') && this.selectedTitles.indexOf(selected) === -1) {
        this.selectedTitles.push(selected);
      } else {
        let index = this.selectedTitles.indexOf(selected);
        if (index > -1) this.selectedTitles.splice(index, 1);
      }
    } else if (type === 'style') {
      let selected: Style|null = null;
      for (const style of this.styles) {
        if (String(style.id) === identifier) {
          selected = style;
          break;
        }
      }
      if (! selected) return;

      if (element.is(':checked') && this.selectedStyles.indexOf(selected) === -1) {
        this.selectedStyles.push(selected);
      } else {
        let index = this.selectedStyles.indexOf(selected);
        if (index > -1) this.selectedStyles.splice(index, 1);
      }
    }

    this.applyFilters();
  }

  private applyFilters() {
    this.syncFilterUi();
    this.app.eventManager.fire('calendar-filters.change', this.getPayload());
  }

  private getPayload() {
    return {
      titles: this.selectedTitles.map((title) => title.id),
      styles: this.selectedStyles.map((style) => style.id),
      search: this.searchText
    };
  }

  private syncFilterUi() {
    $('#title-filter-count').text(this.selectedTitles.length);
    $('#style-filter-count').text(this.selectedStyles.length);
    this.renderSelectedSummary();
  }

  private renderSelectedSummary() {
    const wrapper = $('#calendar-active-filters');
    const chipContainer = wrapper.find('.mc-calendar-active__chips');
    const emptyState = wrapper.find('.mc-calendar-active__empty');
    const clearButton = $('#calendar-clear-filters');
    const chips: string[] = [];

    if (this.searchText) {
      chips.push(`
        <span class="calendar-filter-chip calendar-filter-chip--search">
          <span class="calendar-filter-chip__label">Search: ${this.searchText}</span>
          <button type="button" class="calendar-filter-chip__remove" data-type="search" aria-label="Remove search filter">
            <i class="fa fa-times"></i>
          </button>
        </span>
      `);
    }

    for (const title of this.selectedTitles) {
      chips.push(`
        <span class="calendar-filter-chip">
          <span class="calendar-filter-chip__label">${title.name}</span>
          <button type="button" class="calendar-filter-chip__remove" data-type="title" data-id="${title.id}" aria-label="Remove ${title.name} title filter">
            <i class="fa fa-times"></i>
          </button>
        </span>
      `);
    }

    for (const style of this.selectedStyles) {
      chips.push(`
        <span class="calendar-filter-chip">
          <span class="calendar-filter-chip__swatch" style="color:#${style.color || '000000'};background:#${style.bgcolor || 'ffffff'};"></span>
          <span class="calendar-filter-chip__label">${style.name}</span>
          <button type="button" class="calendar-filter-chip__remove" data-type="style" data-id="${style.id}" aria-label="Remove ${style.name} style filter">
            <i class="fa fa-times"></i>
          </button>
        </span>
      `);
    }

    chipContainer.html(chips.join(''));
    const hasFilters = chips.length > 0;
    emptyState.toggle(! hasFilters);
    clearButton.prop('disabled', ! hasFilters);
  }

  private clearSearch() {
    this.searchText = '';
    $('input#search').val('');
    this.applyFilters();
  }

  private clearAllFilters() {
    this.searchText = '';
    this.selectedTitles = [];
    this.selectedStyles = [];

    $('input#search').val('');
    $('input.filter-inputs').prop('checked', false);

    this.applyFilters();
  }

  private removeChip(element: JQuery<HTMLElement>) {
    const type = element.data('type') as string;

    if (type === 'search') {
      this.clearSearch();
      return;
    }

    const identifier = element.data('id');
    const target = $(`input.filter-inputs[data-type="${type}"][value="${identifier}"]`).first();
    if (! target.length) {
      return;
    }

    target.prop('checked', false);
    this.submitFilter(target);
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/calendar-filters.ts